import { Component, OnInit } from '@angular/core';
import {NavParams} from "@ionic/angular";
import {GetDataService} from "../../services/getdata.service";

@Component({
  selector: 'app-details-modal',
  templateUrl: './details-modal.component.html',
  styleUrls: ['./details-modal.component.scss'],
})
export class DetailsModalComponent implements OnInit {

  public item = null;
  public details = [];

  constructor(
    private navParams: NavParams,
    private getDataService: GetDataService
  ) { }

  ngOnInit() {
    const result = this.navParams.data.item;
    if (result) {
      this.item = result;

      if (result.icd_id) {
        this.getDataService.doDetailsSearch(result.icd_id, 4).then((res) => {
          this.details = res;
        }).catch((e) => {});
      }
    }
  }

}
